export const store = {
  debug: true,
  state: {
    volume: 0.7,
  },
  // setVolume(volume: number): void {
  //   this.state.volume = volume;
  // }
};
